import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const DISPUTE_PERMISSIONS = { MEDIATE: PERMISSIONS.DISPUTES_MEDIATE };
export const DISPUTE_QUERY_KEYS = queryKeys.disputes;
export const DISPUTE_STATUSES = ['OPEN', 'IN_REVIEW', 'CLARIFICATION', 'DECISION_ISSUED', 'CLOSED'];
export const UNDER_REVIEW_STATUSES = ['IN_REVIEW', 'CLARIFICATION', 'DECISION_ISSUED'];
export const DISPUTE_TYPES = ['QUANTITY_SHORTAGE', 'DAMAGED_GOODS', 'DELIVERY_DELAY', 'CONTRACT_VIOLATION', 'INVOICE_ISSUE', 'QUALITY', 'OTHER'];
export const DISPUTE_DECISIONS = ['FULL_REFUND', 'PARTIAL_REFUND', 'NO_ACTION', 'CONTRACT_ADJUSTMENT'];
